import classNames from 'classnames';
import React from 'react';
import SkeletonLoader from '@/components/atoms/skeleton-loader/skeleton-loader';
import Typography from '@/components/atoms/typography/typography';
import IconLabel from '@/components/molecules/icon-label/icon-label';
import Container from '@/components/utilities/container/container';
import styles from './benefit-module.module.scss';

export type BenefitModuleProps = Omit<
  Content.Components['BenefitModuleDto'],
  '$type' | 'id' | 'pageId' | 'settings'
> & {
  /** The class name to apply */
  className?: string;
  /** Whether the module is loading */
  isLoading?: boolean;
};

const BenefitModule = ({
  benefits = [],
  className,
  headline,
  isLoading,
}: BenefitModuleProps) => {
  if (isLoading) {
    return (
      <div className={classNames(styles.component, styles.isLoading)}>
        <div className={styles.container}>
          <SkeletonLoader
            className={styles.loader}
            height="24px"
            width="100%"
          />

          <div className={styles.benefitsList}>
            {Array.from({ length: 3 }).map((_, itemIndex) => (
              <div key={itemIndex} className={styles.item}>
                <SkeletonLoader
                  borderRadius="999px"
                  height="24px"
                  width="24px"
                />

                <SkeletonLoader
                  className={styles.loader}
                  height="20px"
                  width="100%"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={classNames(styles.component, className)}>
      <Container className={styles.container}>
        {headline && <Typography tagStyle="headingSmall" text={headline} />}

        {benefits.length > 0 && (
          <div className={styles.benefitsList}>
            {benefits.map((benefit, benefitIndex) => (
              <div key={benefitIndex}>
                <IconLabel
                  hasIconBackground
                  icon={benefit.icon}
                  iconClassName={styles.benefitIcon}
                  isAnimated={benefit.animate}
                  isLoyalty={benefit.isLoyalty}
                  text={benefit.headline}
                />
              </div>
            ))}
          </div>
        )}
      </Container>
    </div>
  );
};

BenefitModule.displayName = 'BenefitModule';

export default BenefitModule;
